module.exports = __webpack_public_path__ + "img/2abefa1.jpg";